import Vue from 'vue';
import axios from 'axios';

// Interceptor responsável por Exibir e esconder
// o spinner em todas requisições AJAX
axios.interceptors.request.use(
  (config) => {
    Vue.$spinner.show();
    Vue.$loaderOverlay.show();
    return config;
  },
);

axios.interceptors.response.use(
  (response) => {
    Vue.$spinner.hide();
    Vue.$loaderOverlay.hide();
    return response;
  },
  (error) => {
    Vue.$spinner.hide();
    Vue.$loaderOverlay.hide();
    return Promise.reject(error);
  },
);



// WEBPACK FOOTER //
// ./src/interceptors/LoadingInterceptor.js